import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const initReviewsScript = () => {
  const section = document.querySelector('.review');
  if (!section) return;

  const wrapper = section.querySelector('.review__wrapper');
  wrapper?.classList.remove('gap-5');

  new Swiper('.review__container', {
    slidesPerView: 'auto',
    loop: false,
    navigation: {
      nextEl: '.review__button--next.swiper-button-next',
      prevEl: '.review__button--prev.swiper-button-prev',
      disabledClass: 'pointer-events-none opacity-30',
    },
    breakpoints: {
      340: { slidesPerView: 1, spaceBetween: 20 },
      1024: { slidesPerView: 2, spaceBetween: 20 },
    },
  });
};
